export enum VideoRecordingProtocolResult {
  FullRecording = 'full_recording',
  PartialRecording = 'partial_recording',
  NoRecording = 'no_recording',
  PendingResult = 'pending_result',
}
